export default __webpack_public_path__ + "static/media/headshot.25bbeda6.jpeg";